import NewArrivalBigCard from "../products/NewArrivalBigCard"
import NewArrivalSmallCard from "../products/NewArrivalSmallCard"

// =============================================================
type Props = {
  items: any[]
}
// =============================================================

export default function NewProductsGrid({ items }: Props) {
  const mainBlock = items[0] ?? {}
  const smallBlocks = items[1]?.children ?? []
  return (
    <div className="max-w-[--content-width]">
      <div className="grid grid-cols-1 md:grid-cols-[40%_60%] gap-5">
        {mainBlock?.children && mainBlock?.logo ? (
          <NewArrivalBigCard
            products={mainBlock?.children}
            logo={mainBlock?.logo}
            description={mainBlock?.description}
            bgColor={mainBlock?.style?.background}
            link={mainBlock?.url}
          />
        ) : null}
        <div className="grid grid-cols-2 gap-5">
          {smallBlocks.map((block: any, index: number) => (
            <div key={index}>
              <NewArrivalSmallCard
                products={block?.children}
                logo={block?.logo}
                bgColor={block?.style?.background}
                link={block.url}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
